import React from 'react';

import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import type { NameLookupEntry } from '~/hooks/apis/buildNameLookupMap';

import type { SearchImpressionRow } from '~/services/ReproduceSearchService';

import { renderLookupName } from './searchMatchFields';

type Props = {
  impressions: Array<SearchImpressionRow>;
  offerNamesById: Map<string, NameLookupEntry>;
};

function formatProductAvailable(value: boolean | null) {
  if (value === null) {
    return '';
  }

  return value ? 'Yes' : 'No';
}

function renderOfferName(offerId: string | null, offerNamesById: Map<string, NameLookupEntry>) {
  if (!offerId) {
    return '';
  }

  return renderLookupName(offerNamesById.get(offerId), '—');
}

export default function ImpressionsSection({ impressions, offerNamesById }: Props) {
  return (
    <Card elevation={0}>
      <CardContent sx={{ py: 1 }}>
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          Offers impressions
        </Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Position</TableCell>
                <TableCell>Offer ID</TableCell>
                <TableCell>Offer name</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Product</TableCell>
                <TableCell>Product available</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {impressions.map((impression, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{impression.offerId ?? ''}</TableCell>
                  <TableCell>{renderOfferName(impression.offerId, offerNamesById)}</TableCell>
                  <TableCell>{impression.categoryId ?? ''}</TableCell>
                  <TableCell>{impression.productId ?? ''}</TableCell>
                  <TableCell>{formatProductAvailable(impression.productAvailable)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
